import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function FinalCTA() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <section
      className="relative py-28 overflow-hidden"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/24ce2de71c91b69514fa6b08fd316137.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-gray-950/85 via-gray-900/65 to-gray-800/35"></div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-xl">
          <span className="inline-block text-blue-300 text-xs font-semibold tracking-widest uppercase mb-5">{t('finalCta.badge')}</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-white leading-tight mb-5" style={{ fontFamily: "'Inter', sans-serif" }}>
            {t('finalCta.title').split('\n').map((line, i, arr) => (
              <span key={i}>{line}{i < arr.length - 1 && <br />}</span>
            ))}
          </h2>
          <p className="text-base text-white/65 mb-10 leading-relaxed">
            {t('finalCta.desc')}
          </p>
          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => navigate('/contact')}
              className="whitespace-nowrap inline-flex items-center gap-2 bg-white text-blue-700 hover:bg-blue-50 font-semibold px-8 py-4 rounded-full transition-all duration-200 text-sm cursor-pointer"
            >
              {t('finalCta.primary')} <i className="ri-arrow-right-line text-base"></i>
            </button>
            <button
              onClick={() => navigate('/services')}
              className="whitespace-nowrap inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 border border-white/30 text-white font-medium px-8 py-4 rounded-full transition-all duration-200 text-sm cursor-pointer backdrop-blur-sm"
            >
              {t('finalCta.secondary')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
